export const MODULE_NAME = 'map'

export const ACTIONS = {
}

export const GETTERS = {
}

export const MUTATIONS = {
  SET_VIEWSTATE: 'setViewState',
  CENTER_BBOX: 'centerBBox',
  RESET_VIEWSTATE: 'resetViewstate',
  FLY_TO: 'flyTo',
  ZOOM_IN: 'zoomIn',
  ZOOM_OUT: 'zoomOut'
}
